import { useMemo, useState, useEffect, useCallback } from 'react';

import { Stack, Button } from '@mui/material';

/* tema customizado*/
import tableThemeCustom from '../../form/tableThemeCustom';
import { getInitialTabKey } from '../../../utils/profileTabs';
import { useMRTState } from '../../../hooks/useMRTState';

/* hooks */
import { useNavigateParams } from '../../../hooks/useNavigateParams';

/* TABS PANEL */
import SystemTabs from '../../../ui/SystemTabs';
import { buildPessoaTabs } from './tabs/buildPessoaTabs';
import { resolvePessoaProfile } from './profile/resolvePessoaProfile';

import { usePessoaModule } from './modules/usePessoaModule';
import { usePessoaFisicaModule } from './modules/usePessoaFisicaModule';
import { usePessoaJuridicaModule } from './modules/usePessoaJuridicaModule';
import { usePessoaNomeModule } from './modules/usePessoaNomeModule';
import { usePessoaTabelaPrecoModule } from './modules/usePessoaTabelaPrecoModule';
import { usePessoaEmailModule } from './modules/usePessoaEmailModule';
import { usePessoaTelefoneModule } from './modules/usePessoaTelefoneModule';
import { usePessoaEnderecoModule } from './modules/usePessoaEnderecoModule';
import { usePessoaFuncionarioModule } from './modules/usePessoaFuncionarioModule';
import { usePessoaEmpresaModule } from './modules/usePessoaEmpresaModule';
import { usePessoaImagemModule } from './modules/usePessoaImagemModule';
import { usePessoaUsuarioModule } from './modules/usePessoaUsuarioModule';
import { usePessoaColaboradorModule } from './modules/usePessoaColaboradorModule';

/* helpers */
import { getPessoaTabsVisibility } from './helpers/getPessoaTabsVisibility';

/* API's */

//import { json } from "react-router-dom";
const onlyNumbers = (str) => str.replace(/[^0-9]/g, '');

//variavel para constrolar os acessoa a API receitaws, só permite 3 consultas por minuto
let lastQueryTime = 0;
let totalConsultasAPI = 0;

function Form({
    token,
    handleSubmit,
    formData,
    parametro,
    tipo,
    btnText,
    params,
    caminhoVoltar,
    EnumTipo,
    EnumVinculoFinanceiro,
    EnumOrigem,
    EnumSexo,
    EnumTipoSanguineo,
    EnumEstadoCivil,
    EnumCnhCategoria,
    EnumRamoAtividade,
    EnumPJTipo,
    EnumTipoEndereco,
    EnumTipoEmail,
    EnumTipoTelefone,
    ufs,
    municipios,
    optionsEmpresa,

    optionsPais,
    optionsCnhCategoria,

    navigate,
    setFlashMessage,

    consultaDatalist,

    empresaId,
    empresaIds,
}) {
    //situação para submeter o formulario e evitar vários clicks
    const [isSubmitting, setIsSubmitting] = useState(false);

    const profile = resolvePessoaProfile(tipo);
    const initialTabKey = useMemo(() => getInitialTabKey(profile, { defaultKey: 'cabecalho' }), [profile]);

    // Modules
    const pessoaModule = usePessoaModule({ formData, tipo, empresaIds, btnText, navigate, params, setFlashMessage });
    const pessoaImagemModule = usePessoaImagemModule({
        dados: pessoaModule.dados,
        setDados: pessoaModule.setDados,
    });
    const pessoaFisicaModule = usePessoaFisicaModule({
        pessoaId: pessoaModule.dados?.id,
        pessoaFisica: pessoaModule.pessoaFisica,
        setPessoaFisica: pessoaModule.setPessoaFisica,
    });
    const pessoaJuridicaModule = usePessoaJuridicaModule({
        pessoaId: pessoaModule.dados?.id,
        empresaId,
        pessoaJuridica: pessoaModule.pessoaJuridica,
        setDadosPai: pessoaModule.setDados,
    });
    const pessoaTabelaPrecoModule = usePessoaTabelaPrecoModule({
        pessoaId: pessoaModule.dados?.id,
        empresaId: pessoaModule.dados?.empresaId,
        rows: pessoaModule.pessoaTabelaPrecos,
        setRows: pessoaModule.setPessoaTabelaPrecos,
        setFlashMessage,
    });
    const pessoaEmailModule = usePessoaEmailModule({
        pessoaId: pessoaModule.dados?.id,
        rows: pessoaModule.pessoaEmails,
        setRows: pessoaModule.setPessoaEmail,
        setFlashMessage,
    });
    const pessoaTelefoneModule = usePessoaTelefoneModule({
        pessoaId: pessoaModule.dados?.id,
        rows: pessoaModule.pessoaTelefones,
        setRows: pessoaModule.setPessoaTelefone,
        setFlashMessage,
    });
    const pessoaEnderecoModule = usePessoaEnderecoModule({
        pessoaId: pessoaModule.dados?.id,
        rows: pessoaModule.pessoaEnderecos,
        setRows: pessoaModule.setPessoaEndereco,
        setFlashMessage,
    });
    const pessoaNomeModule = usePessoaNomeModule({
        pessoaId: pessoaModule.dados?.id,
        rows: pessoaModule.pessoaNomes,
        setRows: pessoaModule.setPessoaNome,
        setFlashMessage,
    });
    const pessoaFuncionarioModule = usePessoaFuncionarioModule({
        pessoaId: pessoaModule.dados?.id,
        empresaId: pessoaModule.dados?.empresaId,
        rows: pessoaModule.pessoaFuncionarios,
        setRows: pessoaModule.setPessoaFuncionarios,
        setFlashMessage,
    });
    const pessoaEmpresaModule = usePessoaEmpresaModule({
        pessoaId: pessoaModule.dados?.id,
        rows: pessoaModule.pessoaEmpresas,
        setRows: pessoaModule.setPessoaEmpresas,
        setFlashMessage,
    });
    const pessoaUsuarioModule = usePessoaUsuarioModule({
        pessoaUsuario: pessoaModule.pessoaUsuario,
        setPessoaUsuario: pessoaModule.setPessoaUsuario,
        pessoa: pessoaModule.dados,
        pessoaEmpresas: pessoaModule.pessoaEmpresas,
        empresaIds,
        empresaId,
    });
    const pessoaColaboradorModule = usePessoaColaboradorModule({
        pessoaId: pessoaModule.dados?.id,
        pessoaColaborador: pessoaModule.pessoaColaborador,
        funcionario: pessoaModule?.dados?.funcionario,
        setDadosPai: pessoaModule.setDados,
    });

    // -----------------------------
    // MODULES
    // -----------------------------

    const modules = {
        pessoa: pessoaModule,

        imagem: pessoaImagemModule,

        fisica: pessoaFisicaModule,

        juridica: pessoaJuridicaModule,

        usuario: pessoaUsuarioModule,

        colaborador: pessoaColaboradorModule,

        emails: pessoaEmailModule,

        telefones: pessoaTelefoneModule,

        enderecos: pessoaEnderecoModule,

        nomes: pessoaNomeModule,

        funcionarios: pessoaFuncionarioModule,

        filiais: pessoaEmpresaModule,

        tabelaPrecos: pessoaTabelaPrecoModule,
    };

    // -----------------------------
    // MRT STATES
    // -----------------------------

    const mrts = {
        emails: useMRTState({
            storageKey: 'pessoa.emails',
            pageSizeDefault: parametro?.paginacao ?? 5,
        }),

        telefones: useMRTState({
            storageKey: 'pessoa.telefones',
            pageSizeDefault: parametro?.paginacao ?? 5,
        }),

        enderecos: useMRTState({
            storageKey: 'pessoa.enderecos',
            pageSizeDefault: parametro?.paginacao ?? 5,
        }),

        nomes: useMRTState({
            storageKey: 'pessoa.nomes',
            pageSizeDefault: parametro?.paginacao ?? 5,
        }),

        funcionarios: useMRTState({
            storageKey: 'pessoa.funcionarios',
            pageSizeDefault: parametro?.paginacao ?? 5,
        }),

        filiais: useMRTState({
            storageKey: 'pessoa.filiais',
            pageSizeDefault: parametro?.paginacao ?? 5,
        }),

        tabelaPrecos: useMRTState({
            storageKey: 'pessoa.tabelaPrecos',
            pageSizeDefault: parametro?.paginacao ?? 5,
        }),
    };

    const tabsVisibility = useMemo(() => getPessoaTabsVisibility(pessoaModule.dados, profile), [pessoaModule.dados, profile]);

    const submit = (e) => {
        e.preventDefault();

        const payload = { ...pessoaModule.dados, scope: profile?.key || tipo || 'pessoa' };

        if (payload.CPForCNPJ) {
            payload.CPForCNPJ = onlyNumbers(payload.CPForCNPJ);
        }

        if (isSubmitting) return;
        //setIsSubmitting(true);
        handleSubmit(payload);
    };

    /* modo tema */
    const theme = tableThemeCustom();

    const tabsConfigFinal = useMemo(
        () =>
            buildPessoaTabs({
                profile,
                theme,
                modules,
                mrts,

                tabsVisibility,

                consultaDatalist,

                EnumTipo,
                EnumVinculoFinanceiro,
                EnumSexo,
                EnumTipoSanguineo,
                EnumEstadoCivil,
                optionsPais,
                EnumCnhCategoria,
                EnumRamoAtividade,
                EnumPJTipo,
                EnumTipoEndereco,
                EnumTipoEmail,
                EnumTipoTelefone,
                EnumOrigem,

                optionsEmpresa,

                optionsCnhCategoria,

                ufs,
                municipios,

                setFlashMessage,
            }),
        [
            profile,
            theme,
            modules,
            mrts,

            EnumTipo,
            EnumVinculoFinanceiro,
            EnumSexo,
            EnumTipoSanguineo,
            EnumEstadoCivil,
            EnumRamoAtividade,
            EnumPJTipo,
            EnumTipoEndereco,
            EnumTipoEmail,
            EnumTipoTelefone,
            EnumOrigem,

            optionsEmpresa,

            optionsCnhCategoria,

            ufs,
            municipios,

            setFlashMessage,
        ]
    );

    return (
        <form onSubmit={submit}>
            <h1>{profile?.labelForm || 'Gestão de Pessoas'}</h1>

            <SystemTabs tabs={tabsConfigFinal} initialKey={profile?.initialTabKey || 'cabecalho'} />

            <div>
                <Stack direction="row" spacing={1}>
                    <Button variant="contained" color="secondary" onClick={() => navigate(caminhoVoltar, params)}>
                        Voltar
                    </Button>
                    <Button
                        type="submit"
                        variant="contained"
                        color="success"
                        disabled={!pessoaModule.dados?.nomePrincipal || isSubmitting}
                    >
                        {btnText}
                    </Button>
                </Stack>
            </div>
        </form>
    );
}

export default Form;
